import { PageHeader } from '@ant-design/pro-layout'
import type { ViewFieldsFragment } from '@salescore/client-api'
import type { ViewConfigField } from '@salescore/core'
import { Empty, type ModalFuncProps } from 'antd'
import { t } from 'i18next'
import type { ReactElement } from 'react'
import { useSetRecoilState } from 'recoil'

import { configAtom, useViewConfigSheet } from '../../../recoil/viewConfig'
import { MeasureForm } from '../footer/MeasureForm'

export const buildMeasureFormModalProperties = ({
  field,
  measureName,
  onFinish,
  view,
  setHasChangeToViewSchema,
}: {
  field: ViewConfigField
  // eslint-disable-next-line sonarjs/no-redundant-optional
  measureName?: string | undefined
  onFinish: () => void
  view: ViewFieldsFragment
  setHasChangeToViewSchema: (hasChangeToViewSchema: boolean) => void
}): ModalFuncProps => ({
  icon: null,
  width: '90%',
  cancelText: t(`閉じる`),
  okButtonProps: { style: { display: 'none' } },
  style: { top: '3%', padding: 0 },
  destroyOnClose: true,
  maskClosable: true,
  footer: <></>,
  content: (
    <Body
      field={field}
      measureName={measureName}
      onFinish={onFinish}
      view={view}
      setHasChangeToViewSchema={setHasChangeToViewSchema}
    />
  ),
})

const Body = ({
  field,
  measureName,
  onFinish,
  view,
  setHasChangeToViewSchema,
}: {
  field: ViewConfigField
  measureName: string | undefined
  onFinish: () => void
  view: ViewFieldsFragment
  setHasChangeToViewSchema: (hasChangeToViewSchema: boolean) => void
}): ReactElement => {
  const sheetConfig = useViewConfigSheet() // XXX: viewからconfigを取得するとmeasuresが削除されている…？詳細不明
  const setConfig = useSetRecoilState(configAtom)

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (sheetConfig.type !== 'sheet') {
    return <Empty description={t(`ビューが見つかりません`)} />
  }

  return (
    <PageHeader title={t(`集計設定`)}>
      <MeasureForm
        sheetView={{
          ...view,
          config: sheetConfig,
        }}
        field={field}
        measureName={measureName}
        onFinish={({ sheetViewConfig }) => {
          if (sheetViewConfig?.type === 'sheet') {
            setConfig(sheetViewConfig)
            setHasChangeToViewSchema(true)
          }
          onFinish()
        }}
      />
    </PageHeader>
  )
}
